var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticStyle:{"background":"#fff"}},[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }